module.exports = __webpack_public_path__ + "static/img/13.da996bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/zh/13.png
// module id = lwD5
// module chunks = 0